import { render, staticRenderFns } from "./SocialguardAvatar.vue?vue&type=template&id=5ea6de46&"
import script from "./SocialguardAvatar.vue?vue&type=script&lang=js&"
export * from "./SocialguardAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports